import React from "react";
import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";

const getDatetimeWithTimezone = (datetimeLocalValue) => {
  if (!datetimeLocalValue) return "";

  // Get the timezone of the user's system
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // Convert the local datetime to a Date object in the user's timezone
  const zonedDate = utcToZonedTime(datetimeLocalValue, timeZone);

  // Format the zoned date to the desired string format
  const formattedDate = format(zonedDate, "yyyy-MM-dd'T'HH:mm:ss.SSSxxx");

  return formattedDate;
};

const getLocalDatetimeString = (datetime) => {
  if (!datetime) return "";

  // Convert the ISO datetime string to a Date object
  const date = new Date(datetime);

  // Format the date object to datetime-local string format
  return format(date, "yyyy-MM-dd'T'HH:mm");
};

const AppointmentDateField = ({ appointmentDate, setAppointmentDate }) => {
  return (
    <div
      className="flex flex-row items-center justify-center w-full h-12 px-3 Xbg-red-500
                 rounded-lg 
                 border border-1 border-neutral-300
                "
    >
      <input
        value={getLocalDatetimeString(appointmentDate)}
        onChange={(e) => {
          const adjustedDatetime = getDatetimeWithTimezone(e.target.value);
          setAppointmentDate(adjustedDatetime);
        }}
        type="datetime-local"
        className="bg-transparent focus:outline-none focus:ring-inset focus:ring-neutral-300 text-xl"
      />
    </div>
  );
};

export default AppointmentDateField;
